/**
 * Replaces tag placeholders in the content string with their corresponding values.
 * 
 * @param {string} content - The string containing placeholders (e.g., "#dog").
 * @param {Object} tags - An object mapping tag names to replacement values.
 * @returns {string} - The content string with placeholders replaced.
 */
export function replaceTags(content, tags) {
  if (!content || typeof content !== "string") return "";
  if (!tags || typeof tags !== "object") return content;

  return content.replace(/#(\w+)/g, (match, tagName) => {
    return tags.hasOwnProperty(tagName) ? tags[tagName] : match;
  });
}